import React from "react";
import { Routes, Route } from 'react-router-dom'
import Box from '@mui/material/Box';
import Home from "../pages/Home";
import DrawBox from "../pages/DrawBox";
import SigilToolbar from "../components/toolbar/SigilToolbar";
import InfoPage from "../pages/InfoPage";
import MySigils from "../pages/MySigils";
import "../App.css";
import CustomSnackbar from "../components/customSnackbar/CustomSnackbar";
import DrawerImage from "../components/drawerImage/DrawerImage";
import Policy from "./Policy";
import About from "./About";
import InviteMeCoffee from "./InviteMeCoffee";
import ViewSigile from "./ViewSigile";
import Forum from "./Forum";
import Grimoire from "./Grimoire";
import Article from "./Article";
import FAQ from "./FAQ";
import Footer from "../components/footer/Footer";



function Main() {


  return (
    <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      < SigilToolbar />
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="drawing" element={<DrawBox />} />
          <Route path="info" element={<InfoPage />} />
          <Route path="my-sigils" element={<MySigils />} />
          <Route path="policy" element={<Policy />} />
          <Route path="about" element={<About />} />
          <Route path="coffee" element={<InviteMeCoffee />} />
          <Route path="view/:id" element={<ViewSigile />} />
          <Route path="forum" element={<Forum />} />
          <Route path="grimoire" element={<Grimoire />} />
          <Route path="grimoire/:id" element={<Article />} />
          <Route path="faq" element={<FAQ />} />
        </Routes>
      </Box>
      <CustomSnackbar />
      <DrawerImage />
      <Footer />
    </div>
  );
}

export default Main;
